import { render, staticRenderFns } from "./DataCellList.vue?vue&type=template&id=baad90e0&scoped=true&"
import script from "./DataCellList.vue?vue&type=script&lang=js&"
export * from "./DataCellList.vue?vue&type=script&lang=js&"
import style0 from "./DataCellList.vue?vue&type=style&index=0&id=baad90e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baad90e0",
  null
  
)

export default component.exports